import { Expose } from 'class-transformer';
import { Point } from 'geojson';

import { SnModel } from '@lib/common/models';

export class SnFloorPlan extends SnModel {
  @Expose()
  public image: string;

  @Expose()
  public name: string;

  @Expose()
  public swPoint: Point;

  @Expose()
  public nePoint: Point;

  @Expose()
  public rotation: number;

  @Expose()
  public floor: string;

  @Expose()
  public id: string;

  @Expose()
  public url: string;

  @Expose()
  public bbox: any;

  @Expose()
  public pending: boolean;

  @Expose()
  public createdTimestamp: string;

  @Expose()
  public updatedTimestamp: string;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
